const $ = require('jquery');
import _ from "underscore";
import render from "../../utilities/render";
import {setElementsFromScope} from "../../utilities/selectorHelpers";
import { militaryToPeriodTime } from "../../utilities/general";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";
import EditChecker from '../../components/EditChecker/EditChecker';

require("./standardPlatformFacilitySetupWizard.less");
// Additional Imports...

const facCertNamesTemplateHtml = require('./html/rowTemplate.html');
const reviewCalendarRows = require("./html/reviewCalendarRows.html");
let submitModal;
let facilityObj = {}; //preparedataforsubmit


//HB-12294
const elementsMap = {
  srcDetTabFacName: "#fac-name",
  destReviewTabFacName: "#destination-tab-fac-name",
  srcDetTabFacCode: "#fac-code",
  destReviewTabFacCode: "#destination-tab-fac-code",
  srcDetTabFacBldgNo: "#fac-bldgno",
  destReviewTabFacBldgNo: "#destination-tab-fac-bldgno",
  srcDetTabFacBusUnit: "#fsc-business-unit",
  destReviewTabFacBusUnit: "#destination-tab-fsc-business-unit",  
  srcDetTabFacOwn:"#facilitySharedAction",  
  destReviewTabFacOwnership: "#destination-tab-fsc-Ownership",
  srcDetTabFacLeese :"#facility-lessee",
  srcDetTabFacOwner :"#facility-owner",  
  destReviewTabFacOwnershipVal :"#destination-tab-fsc-OwnLbl",
  destReviewTabFacOwner:"#destination-tab-fsc-Owner",
  srcDetTabFacGoLiveDateParent:"#facility-go-live-date-parent",
  destReviewTabFacGoLiveDate:"#destination-tab-fac-go-live-date",
  srcDetTabFacClosedDateParent:"#facility-closed-date-parent",
  destReviewTabFacClosedDate:"#destination-tab-fac-closed-date",
  srcDetTabFacCertificationSwitch: "#fac-certificate-switch",
  destReviewTabFacCertificates:"#destination-tab-fac-cert-names",
  destReviewTabFacNoCertificates:"#destination-tab-fac-no-cert-names",
  srcDetTabFacYrdMgmt :"#yardmanagement",
  destReviewTabFacYrdMgmtYes:"#destination-tab-yard-management-yes",
  destReviewTabFacYrdMgmtNo:"#destination-tab-yard-management-no",
  srcDetTabFacInboundAppt :"#inboundappointment",
  destReviewTabFacInboundApptYes:"#destination-tab-inbound-appointment-yes",
  destReviewTabFacInboundApptNo:"#destination-tab-inbound-appointment-no",  
  srcAddTabFacCountry :"#fac-address-tab-country",
  destReviewTabFacCountry : "#destination-tab-fac-country",
  srcAddTabFacAddress1:"#fac-address-tab-address1",
  destReviewTabFacAddress1: "#destination-tab-fac-address1",
  srcAddTabFacAddress2:"#fac-address-tab-address2",
  destReviewTabFacAddress2:"#destination-tab-fac-address2",
  srcAddTabFacCity:"#fac-address-tab-city",
  srcAddTabFacState:"#fac-address-tab-state",
  srcAddTabFacStateText:"#fac-address-tab-stateText",
  srcAddTabFacZipCode: "#fac-address-tab-zip",
  destReviewTabFacCityStateZip:"#destination-tab-fac-citystatezip",
  srcAddTabFacTimeZone:"#fac-address-tab-timezone",
  destReviewTabFacTimeZone: "#destination-tab-fac-timezone",
  srcAddTabFacContactName: "#fac-address-tab-contact-name",
  destReviewTabFacContactName:"#destination-tab-fac-contactname",
  srcAddTabFacPhonecode:"#fac-address-tab-phone-code",
  srcAddTabFacPhoneNumber:"#fac-address-tab-phone",
  destReviewTabFacPhoneNumber:"#destination-tab-fac-phonenumber",
  srcAddTabFacEmail:"#fac-address-tab-email",
  destReviewTabFacEmail:"#destination-tab-fac-email",
  srcOpsTabFacBldType:".fac-building-type", 
  destReviewTabFacBldgType:"#destination-tab-fac-bldg-type",
  srcOpsTabFacUses:".fac-use-ops-section",
  destReviewTabFacUses:".fcyuse-review-div",  
  srcOpsTabFacInShipDocks:"#ded-inbound-shipment",
  destReviewTabFacInShipDocks:"#destination-tab-ded-inbound-ship-docks",
  srcOpsTabFacOutShipDocks:"#ded-outbound-shipment",
  destReviewTabFacOutShipDocks:"#destination-tab-ded-outound-ship-docks",
  srcOpsTabFacSharedDocks:"#shared-docks",
  destReviewTabFacSharedDocks:"#destination-tab-shared-docks",
  srcOpsTabFacCeilingHt:"#ceiling-height",
  destReviewTabFacCeilingHt:"#destination-tab-ceiling-height",
  destReviewTabFacSqrfootage: ".fcy-sqr-footage",
  srcOpsTabFcySqrFootage:".fac-sqr-footage",
  destReviewTabNoSqrFootage:"#destination-tab-no-sqr-footage",
  destReviewTabSqrFootageSection:"#destination-tab-sqrfootsection",
  reviewCalendarRowsDiv: "#review-calendar-shift-times",
  reviewCalendarNotSetMsg:".calendar-not-set-msg",
  reviewCalendarHeader:".review-calendar-header", 
  submitFacilityButton:".submit-facility-setup-wizard"
};
const els = {};

export default function ReviewTab(wizard){
  const self = this;
  const wizardEl = wizard.getWizardElement();
  const submitURL = wizardEl.data("submit-spl-facility");
  const detailURL = wizardEl.data("facility-detail-url");
  const facData = wizardEl.data("load-edit-facility"); //get the facility data from DB to load edit form
  let shiftTimes; 
  
  //HB-12294 
  function setElements(){
    setElementsFromScope(els, elementsMap, wizardEl);
  }

  self.init = function(){    
    setElements(); 
    generateModals();
    bindElements();
  }  

  function bindElements(){
    els.submitFacilityButton.on('click',showSubmitModal);
  }

  function generateModals(){
    submitModal = new SubmitModalFlow({
      confirmModalTitle: 'Save Facility',
      confirmModalBody: '<div class="q-pad-all-xl">Once you have saved this facility, it can be referenced throughout the application.</div>',
      confirmModalBtnText: 'Save',
      modalDialogClass: "q-modal-dialog-500",
      onConfirmClick: function(){
      submitModal.showLoadingModal();
        $.ajax({
          data: {
            splFacilityData: JSON.stringify(facilityObj)
          },            
          url: submitURL,
          dataType:"JSON",
          type: 'POST',
          success: submitFacilitySuccess,
          error: submitFacilityError
        });
      }
        
    });
    submitModal.init();
    
  };

  function submitFacilitySuccess(resp) {
    const facilityId = resp.data;
    EditChecker.setPageClean();
    submitModal.showSuccessModal();
	  setTimeout(function() {
		 const facilityDetailURL = `${detailURL}&facilityId=${facilityId}`;
		 window.location.href = facilityDetailURL;
      }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
  }

  function submitFacilityError() {
    submitModal.showFailureModal();
  }

  function showSubmitModal(e){
    e.preventDefault();
    submitModal.showConfirmModal();
  }
  self.fillReviewCalendarArea = function(shiftsFromCalendarTab) {
    shiftTimes = shiftsFromCalendarTab;
    if(!_(shiftTimes).isEmpty()) {
      renderCalenderRows(shiftTimes);
      els.reviewCalendarNotSetMsg.hide();
      els.reviewCalendarHeader.show();
      els.reviewCalendarRowsDiv.show();
    } else {
      els.reviewCalendarRowsDiv.hide();
      els.reviewCalendarHeader.hide();
      els.reviewCalendarNotSetMsg.show();
    }
     
  }

  self.fillReviewElementsWithVals = function(){
    fillDetailsElementsWithVals(); //Populate review tab with details tab values
    fillAddressElementsWithVals(); //Populate review tab with address tab values
    fillOperationsElementsWithVals(); //Populate review tab with operations tab values
  }

  function renderCalenderRows(){    
    let calendarRowHtml = [];
    let calendarMap = new Map();
    let dayTimings =[];
    
    Object.keys(shiftTimes).forEach((key)=>{

      dayTimings =[];

      dayTimings.push(shiftTimes[key][0].from);
      dayTimings.push(shiftTimes[key][0].to);
      calendarMap.set(_(key),dayTimings);

      calendarRowHtml.push(render(reviewCalendarRows, {
          key: _(key).capitalize(),
          shiftTime: `${militaryToPeriodTime(shiftTimes[key][0].from)} - ${militaryToPeriodTime(shiftTimes[key][0].to)}`
        }));  

    });
    els.reviewCalendarRowsDiv.html( calendarRowHtml.join(""));

    facilityObj.facCalendar = calendarMap;
  }  

  function fillDetailsElementsWithVals(){
    const fscOwenershipRadio = wizardEl.find(".ownership-radio");
    const fscLeasedRadio = wizardEl.find(".leased");
    const fscOwenedRadio = wizardEl.find(".owned");    

    els.destReviewTabFacName.text(els.srcDetTabFacName.val());
    els.destReviewTabFacCode.text(els.srcDetTabFacCode.val());
    els.destReviewTabFacBldgNo.text(els.srcDetTabFacBldgNo.val());
    els.destReviewTabFacBusUnit.text(els.srcDetTabFacBusUnit.val());
    
    //preparedataforsubmit
    facilityObj.facName = els.srcDetTabFacName.val();
    facilityObj.facCode = els.srcDetTabFacCode.val();
    facilityObj.facBldgNo = els.srcDetTabFacBldgNo.val();
    facilityObj.facBusUnit = els.srcDetTabFacBusUnit.val();
        
    //Set ownership value to label field and dropdown value to respective valueholder

    if(fscOwenershipRadio.is(":checked")){
      if(fscLeasedRadio.is(":checked")){
        els.destReviewTabFacOwnership.text(fscLeasedRadio.val()+":");
        els.destReviewTabFacOwnershipVal.text("Lessee:");
        els.destReviewTabFacOwner.text(els.srcDetTabFacLeese.val());
        facilityObj.facOwnership = fscLeasedRadio.val();
        facilityObj.facOwner = els.srcDetTabFacLeese.val();
      }else if(fscOwenedRadio.is(":checked")){
        els.destReviewTabFacOwnership.text(fscOwenedRadio.val()+":");
        els.destReviewTabFacOwnershipVal.text("Owner:");
        els.destReviewTabFacOwner.text(els.srcDetTabFacOwner.val());
        facilityObj.facOwnership = fscOwenedRadio.val();
        facilityObj.facOwner = els.srcDetTabFacOwner.val();        
      }
    }
    
    els.destReviewTabFacGoLiveDate.text(els.srcDetTabFacGoLiveDateParent.find(".facility-go-live-date").val());
    els.destReviewTabFacClosedDate.text(els.srcDetTabFacClosedDateParent.find(".facility-closed-date").val());   

    facilityObj.facGoLiveDate = els.destReviewTabFacGoLiveDate.text();    
    facilityObj.facClosedDate = els.destReviewTabFacClosedDate.text();
    facilityObj.facCertificateSwitch = "no";
    facilityObj.facCertificates = "";    

    //If certificates switchery is selected, get all the certificate names and append to review tab as row
    
    if(els.srcDetTabFacCertificationSwitch.is(":checked")){
      let certificates = [];
      els.destReviewTabFacNoCertificates.hide();
      els.destReviewTabFacCertificates.text("");

      $("input[name='certificate']").each(function() {
        certificates.push($(this).val());
      });

      facilityObj.facCertificateSwitch = "yes";
      facilityObj.facCertificates = certificates;

       const certificatesnames = (certificates).map((certificatename)=>{
         return render(facCertNamesTemplateHtml, {         
           text: certificatename
         });
       });
      els.destReviewTabFacCertificates.append(certificatesnames.join(''));
    }else{
      els.destReviewTabFacNoCertificates.show();
    }
    
    //Additional information

    if(els.srcDetTabFacYrdMgmt.is(":checked")){
      els.destReviewTabFacYrdMgmtYes.show();
      els.destReviewTabFacYrdMgmtNo.hide();  
      facilityObj.facYrdMgmt = "yes";     
    }else{
      els.destReviewTabFacYrdMgmtYes.hide();
      els.destReviewTabFacYrdMgmtNo.show();   
      facilityObj.facYrdMgmt = "no";    
    }
    
    if(els.srcDetTabFacInboundAppt.is(":checked")){  
      els.destReviewTabFacInboundApptYes.show();
      els.destReviewTabFacInboundApptNo.hide(); 
      facilityObj.facInboundAppt = "yes";         
    }else{
      els.destReviewTabFacInboundApptYes.hide();
      els.destReviewTabFacInboundApptNo.show();
      facilityObj.facInboundAppt = "no";           
    }  
    
  }

  function fillAddressElementsWithVals(){
     if((els.srcAddTabFacCountry.find(":selected").text()) == "United States of America" 
        || (els.srcAddTabFacCountry.find(":selected").text()) == "Canada"){
      els.destReviewTabFacCityStateZip.text(els.srcAddTabFacCity.val()+" "+els.srcAddTabFacState.val()+" "+els.srcAddTabFacZipCode.val());
          
      facilityObj.facCity = els.srcAddTabFacCity.val();
      facilityObj.facState = els.srcAddTabFacState.val();
      facilityObj.facZipCode = els.srcAddTabFacZipCode.val();
    
    }else{
      els.destReviewTabFacCityStateZip.text(els.srcAddTabFacCity.val()+" "+els.srcAddTabFacStateText.val()+" "+els.srcAddTabFacZipCode.val());
    
      facilityObj.facCity = els.srcAddTabFacCity.val();
      facilityObj.facState = els.srcAddTabFacStateText.val();
      facilityObj.facZipCode = els.srcAddTabFacZipCode.val();
    }
    els.destReviewTabFacAddress1.text(els.srcAddTabFacAddress1.val());
    els.destReviewTabFacAddress2.text(els.srcAddTabFacAddress2.val());    
    els.destReviewTabFacCountry.text(els.srcAddTabFacCountry.find(":selected").text());
    els.destReviewTabFacTimeZone.text(els.srcAddTabFacTimeZone.val());
    els.destReviewTabFacContactName.text(els.srcAddTabFacContactName.val());
    els.destReviewTabFacPhoneNumber.text(els.srcAddTabFacPhonecode.val()+" "+els.srcAddTabFacPhoneNumber.val());
    els.destReviewTabFacEmail.text(els.srcAddTabFacEmail.val()); 

    facilityObj.facAddress1 = els.srcAddTabFacAddress1.val();
    facilityObj.facAddress2 = els.srcAddTabFacAddress2.val();
    facilityObj.facCountry = els.srcAddTabFacCountry.find(":selected").val();
    facilityObj.facTimeZone = els.srcAddTabFacTimeZone.val();
    facilityObj.facContactName = els.srcAddTabFacContactName.val();
    facilityObj.facPhoneCode = els.srcAddTabFacPhonecode.val(); 
    facilityObj.facPhone = els.srcAddTabFacPhoneNumber.val();
    facilityObj.facEmail = els.srcAddTabFacEmail.val();

  }

  
  function fillOperationsElementsWithVals(){      
      let opsfcyusecheckboxes = [];    
      let reviewfcyusedivtags =[];
      let srcId;
      let showNoSqrfootage = true;
      let sqrFootId;

       //Populate Building type
    
    _.each((els.srcOpsTabFacBldType), (el)=>{  
      if($(el).is(":checked")){        
        els.destReviewTabFacBldgType.text($(el).val()+":");
        facilityObj.facBuildingType = $(el).val();
      }  
    });  

    
    //Populate facility uses section on review tab
    
    //By default on review page, hide div-yes and show div-no for all fcy use fields.
   
    reviewfcyusedivtags = els.destReviewTabFacUses;     
      _.each(reviewfcyusedivtags, (el)=>{      
        if((el.id).indexOf('-yes')>-1){
            $(el).hide();
        }
        if((el.id).indexOf('-no')>-1){
          $(el).show();
        }        
      });

    //get ops tab fcy uses objects to work with
    opsfcyusecheckboxes = els.srcOpsTabFacUses.find('.fac-use-ops-box');
    
    let selectedFacUse = [];
    let index = 0 ;

    //get review tab fcy uses objects to work with.  
    _.each(opsfcyusecheckboxes, (el)=>{    

        if($(el).is(":checked")){  
          const ele = $(el);        
          srcId = el.id;
          selectedFacUse[index] = ele.val();
          index++;
          _.each(reviewfcyusedivtags, (elr)=>{  
            const eler = $(elr);
            if((elr.id).indexOf(srcId)>-1 && (elr.id).indexOf('-yes')>-1)  {
              eler.show();
            }
            if((elr.id).indexOf(srcId)>-1 && (elr.id).indexOf('-no')>-1)  {
              eler.hide();
            }                  
         });
        }
    });

    facilityObj.facUse = selectedFacUse;
    
     if(els.srcOpsTabFacCeilingHt.val()!=''){
      els.destReviewTabFacCeilingHt.text(els.srcOpsTabFacCeilingHt.val()+" ft."); 
      facilityObj.facCeilingHt = els.srcOpsTabFacCeilingHt.val(); 
     }     
     if(els.srcOpsTabFacInShipDocks.val() != ''){
      els.destReviewTabFacInShipDocks.text(els.srcOpsTabFacInShipDocks.val());
      facilityObj.facInShipDocks = els.srcOpsTabFacInShipDocks.val();  
     }else{
      els.destReviewTabFacInShipDocks.text(0);
      facilityObj.facInShipDocks = "0"; 
     }
     
     if(els.srcOpsTabFacOutShipDocks.val() != ''){
      els.destReviewTabFacOutShipDocks.text(els.srcOpsTabFacOutShipDocks.val());
      facilityObj.facOutShipDocks = els.srcOpsTabFacOutShipDocks.val();
     }else{
      els.destReviewTabFacOutShipDocks.text(0);
      facilityObj.facOutShipDocks = "0";
     }
     
     if(els.srcOpsTabFacSharedDocks.val() != ''){
      els.destReviewTabFacSharedDocks.text(els.srcOpsTabFacSharedDocks.val());
      facilityObj.facSharedDocks = els.srcOpsTabFacSharedDocks.val();
     }else{
      els.destReviewTabFacSharedDocks.text(0);
      facilityObj.facSharedDocks = "0";
     }

     //populate square footage section
     let srqFootageMap = new Map();
     
     //Check to see if any values are entered.
     _.each((els.srcOpsTabFcySqrFootage), (el)=>{
        if($(el).val() != ''){
          showNoSqrfootage = false;
        }        
     });

     if(showNoSqrfootage){
        els.destReviewTabNoSqrFootage.show();
        els.destReviewTabSqrFootageSection.hide();
     }else{
      els.destReviewTabNoSqrFootage.hide();
      els.destReviewTabSqrFootageSection.show();
      _.each((els.srcOpsTabFcySqrFootage), (el)=>{
         _.each((els.destReviewTabFacSqrfootage), (elr)=>{
           if(el.id == elr.id){             
               if((el.id).indexOf('utilized-space-')<0 && (el.id).indexOf('sum-utilized-space')<0){
                if($(el).val() != ''){
                  $(elr).text($(el).val()+" "+"sq. ft.");
                }else{
                  $(elr).text('');
                } 
               }else{                
                 if($(el).val() != ''){
                  $(elr).text($(el).val()+"% Utilization");
                 }else{
                  $(elr).text('');
                 }
               }
               if($(el).val() != ''){ 
                sqrFootId = el.id;
                sqrFootId= sqrFootId.replace("total-sqfoot-","TOTAL_");
                sqrFootId= sqrFootId.replace("available-sqfoot-","AVAILABLE_");
                sqrFootId= sqrFootId.replace("utilized-space-","UTILIZED_");
                sqrFootId= sqrFootId.replace("sum-available-sqfoot","SUM_AVAILABLE");
                sqrFootId= sqrFootId.replace("sum-total-sqfoot","SUM_TOTAL");
                sqrFootId= sqrFootId.replace("sum-utilized-space","SUM_UTILIZED");
                srqFootageMap.set(sqrFootId,$(el).val());
               }

           }
           
         });       
      });
      
      
    }
   

    facilityObj.facSqrFootage = srqFootageMap;

    if(facData != null && facData != ''){
      if(facData.facDeactiveActive == null){
        facilityObj.facActive = "1";
      }else{
        facilityObj.facActive = facData.facDeactiveActive;
      }      
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/standardPlatformFacilitySetupWizard/reviewTab.js